import { Chip, Tooltip } from '@mui/material'
import { observer } from 'mobx-react-lite'

export type CareerGoalChipProps = {
  color?: string
  text: string
  onDelete?: () => void
  showDelete?: boolean
}

export const CareerGoalChip = observer((props: CareerGoalChipProps) => {
  const text = props.text.length > 35 ? `${props.text.slice(0, 32)}...` : props.text

  return (
    <Tooltip title={props.text} arrow>
      <Chip
        color='primary'
        label={text}
        sx={{ fontSize: 12 }}
        onDelete={props.showDelete ? props.onDelete : undefined}
        size='small'
      />
    </Tooltip>
  )
})
